export enum OnboardingRoute {
  Onboarding = 'onboarding',
}

export enum OnboardingPage {
  Welcome = 'welcome',
  CreateTenant = 'create-tenant',
  SignInExperience = 'sign-in-experience',
}
